<template>
  <transition name="fade">
  <div class="title">
    <img class="title" src="@/assets/title.png" alt="What Happened Here" />

    <!-- <h1>What Happened Here</h1> -->
    <!-- <h6>an audio tour of your home at the end of isolation</h6> -->
    <img class="cover" :src="require('@/assets/covers/Cover.jpg')" />
    
    <div class="middle-control">
      <button class="proceed" @click="go">
        <div class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" fill="currentColor" class="bi bi-play" viewBox="0 0 14 14">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"/>
          </svg>
        </div>
      </button>
    </div>

    <div class="bottom-control">
      <!-- <p>mobile device recommended</p> -->
      <img class="logo" src="@/assets/logo.png" alt="Strange Bird Immersive" />
    </div>

  </div>
  </transition>
</template>

<script>
// @ is an alias to /src
// import Title from '@/components/Title.vue'

export default {
  name: 'Home',
  components: {
    // Title
  },
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
    go: function() {    
      this.$router.push('guidelines');
    },
  }
}
</script>

<style scoped>

button .icon {
  width: 85%;
  height: 75%;
  margin-left: auto;
  margin-right:auto;
  margin-bottom: 2vh;
}

button.proceed {
  width: 75vw;
  max-width: 200px;
  height: 75vw;
  max-height: 200px;
}

.bottom-control {
  background-color: white;
  bottom:-6px;
}
img.logo, img.title {
  width: 100%;
  max-width: 500px;
}
</style>